import { IMuWidget } from "./IMuWidget";

export class UiFlashMessage extends IMuWidget
{
	public static instance: UiFlashMessage;

	public afterIndex()
	{
		this.updateVisibility();
		UiFlashMessage.instance = this;
	}

	public updateVisibility() 
	{
		this.container.style.display = this.ui.items.firstElementChild
			? null
			: "none";
	}

	public add(text : string, template : string = 'item') : UiLoaderItem
	{
		var item = this.muWidgetFromTemplate(template, "items", { text: text }) as UiLoaderItem;
		this.updateVisibility();
		return item;
	}
}

export class UiLoaderItem extends IMuWidget
{
	public text : string;

	public showDuration: number|null = 7000;

	public afterIndex()
	{
		this.ui.text.innerText = this.text;
		if (this.showDuration) {
			setTimeout(() => this.container.toggleAttribute('loader-item__removing'), this.showDuration);
			setTimeout(() => this.muRemoveSelf(), this.showDuration + 3000);
		}
	}

	public remove() : void
	{
		this.muRemoveSelf();
		(this.muParent as UiFlashMessage).updateVisibility();
	}

	public bClose_click() : void
	{
		this.remove();
	}
}
